import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ContentService } from './content.service';
import { AnalyticsService } from './analytics.service';
import { Report, RequestResult, SiteContent } from './models';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, OnDestroy {
  content?: SiteContent;

  // banner
  activeSlide = 0;
  private timer: ReturnType<typeof setInterval> | null = null;

  // request form
  form = { name: '', org: '', lane: '', email: '', phone: '', note: '', project: '', wantsCall: false };
  selected: { [title: string]: boolean } = {};
  intent = '';
  submitted = false;
  result?: RequestResult;
  repError = false;
  sending = false;

  //Kent: Make links responsive
  menuOpen = false

  constructor(private api: ContentService, private sanitizer: DomSanitizer, public analytics: AnalyticsService) {}


  //Kent: Make links responsive
  toggleMenu()
  {
	this.menuOpen = !this.menuOpen;
  }

  closeMenu()
  {
	this.menuOpen = false;
  }




  get videoUrl(): SafeResourceUrl | null {
    const id = this.content?.videoId;
    return id ? this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + id) : null;
  }

  ngOnInit(): void {
    this.api.getContent().subscribe(c => {
      this.content = c;
      const firstAvailable = c.reports.find(r => r.status === 'available');
      if (firstAvailable) this.selected[firstAvailable.title] = true;
      this.startRotation();
      setTimeout(() => this.revealCards(), 0);
    });
  }

  ngOnDestroy(): void { this.stop(); }

  // ---------- banner ----------
  get slides(): Report[] { return this.content?.featuredReports ?? []; }
  get featured(): Report | undefined { return this.content?.featuredReports?.[0]; }
  startRotation(): void { this.stop(); if (this.slides.length > 1) this.timer = setInterval(() => this.next(), 6000); }
  stop(): void { if (this.timer) { clearInterval(this.timer); this.timer = null; } }
  go(i: number): void { const n = this.slides.length; if (!n) return; this.activeSlide = (i + n) % n; this.startRotation(); }
  next(): void { this.go(this.activeSlide + 1); }
  prev(): void { this.go(this.activeSlide - 1); }

  // ---------- helpers ----------
  isAvailable(r: Report): boolean { return r.status === 'available'; }
  badge(r: Report): string { return r.status === 'available' ? 'Available now' : 'Coming soon'; }
  payLink(name: string): string | undefined { return this.content?.stripe.services?.[name]; }

  donate(event: Event): void {
    event.preventDefault();
    const url = this.content?.stripe.donate;
    if (url) window.open(url, '_blank', 'noopener');
  }

  selectReport(title: string): void {
    this.selected[title] = true;
    document.getElementById('reportsPick')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  inquire(name: string): void {
    this.intent = name;
    this.analytics.track('service_inquiry', name);
    document.getElementById('request')?.scrollIntoView({ behavior: 'smooth' });
  }

  clearIntent(): void { this.intent = ''; }

  private selectedTitles(): string[] { return Object.keys(this.selected).filter(t => this.selected[t]); }

  // ---------- submit ----------

  //Kent - fix submit to require fields
  //submit(): void
  submit(f: any): void
  {

	if (f.invalid)
	{
		//f.control.markAllAsTouched()
		//const firstInvalid = document.querySelector('input.ng-invalid, select.ng-invalid') as HTMLElement
		//firstInvalid?.focus()
		//return

		Object.values(f.controls).forEach((control: any) =>
		{
			control.markAsTouched()
		})
		const firstInvalid = document.querySelector('input.ng-invalid, select.ng-invalid') as HTMLElement
		firstInvalid?.focus()
		return

	}

	//if (!this.form.name || !this.form.org || !this.form.lane || !this.form.email)
	//{
	//	//return;
	//}
		 

    const items = this.selectedTitles();
    if (this.intent) items.push(this.intent);
    if (items.length === 0) {
      this.repError = true;
      document.getElementById('reportsPick')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    this.repError = false;
    this.sending = true;

    const body = {
      name: this.form.name, org: this.form.org, lane: this.form.lane, email: this.form.email,
      phone: this.form.phone, note: this.form.note, project: this.form.project,
      wantsCall: this.form.wantsCall, reports: items
    };

    this.api.submitRequest(body).subscribe({
      next: r => this.showThankYou(r),
      error: () => this.showThankYou({
        downloads: [], pending: this.selectedTitles(), planningCall: this.form.wantsCall, booking: null
      })
    });
  }

  private showThankYou(r: RequestResult): void {
    this.result = r;
    this.submitted = true;
    this.sending = false;
    this.analytics.ga('request_submitted');
    setTimeout(() => document.getElementById('successMsg')?.scrollIntoView({ behavior: 'smooth', block: 'center' }), 0);
  }

  // ---------- engagement motion ----------
  private revealCards(): void {
    if (!('IntersectionObserver' in window)) return;
    const cards = Array.from(document.querySelectorAll('.scard'));
    if (!cards.length) return;
    cards.forEach(c => c.classList.add('reveal'));
    const io = new IntersectionObserver(entries => {
      entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    cards.forEach(c => io.observe(c));
  }
}
